import React from 'react';
import { motion } from 'framer-motion';
import { Dumbbell, Zap, Apple } from 'lucide-react';
export function MechanismSection() {
  const pillars = [{
    icon: <Dumbbell size={40} className="text-gym-green" data-id="element-222" />,
    title: 'Musculación',
    desc: 'Sin él, tu cuerpo no genera músculo, tu metabolismo no sube.'
  }, {
    icon: <Zap size={40} className="text-gym-gold" data-id="element-223" />,
    title: 'Funcional',
    desc: 'Sin él, tu cuerpo no se mueve bien, las lesiones aparecen, el progreso se frena.'
  }, {
    icon: <Apple size={40} className="text-red-400" data-id="element-224" />,
    title: 'Nutrición',
    desc: 'Sin él, puedes entrenar 2 horas al día y no ver nada si comes mal.'
  }];
  return <section className="py-24 bg-gym-charcoal" data-id="element-225">
      <div className="max-w-6xl mx-auto px-4" data-id="element-226">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-227">
          <h2 className="text-3xl md:text-5xl font-bold mb-6 uppercase tracking-wide text-white" data-id="element-228">
            El descubrimiento que lo{' '}
            <span className="text-gym-green" data-id="element-229">cambia todo</span>
          </h2>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto" data-id="element-230">
            Después de trabajar con decenas de personas en San Miguel que habían
            "fracasado" en otros gimnasios, descubrimos algo importante:
          </p>
          <p className="text-2xl font-bold text-white mt-6 max-w-4xl mx-auto" data-id="element-231">
            Ninguna de ellas había fracasado. Simplemente nunca había tenido los
            3 pilares al mismo tiempo.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16" data-id="element-232">
          {pillars.map((pillar, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.2
        }} className="bg-gym-charcoalLight p-8 rounded-2xl border border-gym-charcoal hover:border-gym-green/30 transition-colors" data-id="element-233">
              <div className="bg-gym-dark w-20 h-20 rounded-full flex items-center justify-center mb-6 mx-auto border border-gym-charcoal" data-id="element-234">
                {pillar.icon}
              </div>
              <h3 className="text-2xl font-bold text-center mb-4 uppercase tracking-wider" data-id="element-235">
                {pillar.title}
              </h3>
              <p className="text-gray-400 text-center text-lg" data-id="element-236">{pillar.desc}</p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: 0.6
      }} className="text-center" data-id="element-237">
          <div className="inline-block bg-gym-green/10 border border-gym-green/50 px-8 py-6 rounded-xl" data-id="element-238">
            <h3 className="text-3xl md:text-4xl font-bold text-white uppercase tracking-wide mb-2" data-id="element-239">
              Los 3 solos no bastan.
            </h3>
            <h3 className="text-3xl md:text-4xl font-bold text-gym-green uppercase tracking-wide" data-id="element-240">
              Juntos, son imparables.
            </h3>
            <p className="text-xl text-gray-300 mt-4 font-medium" data-id="element-241">
              A eso le llamamos el{' '}
              <span className="text-white font-bold" data-id="element-242">Sistema 3en1</span> — y es
              la base de todo lo que hacemos aquí.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}